import React, { useEffect, useState } from 'react'
import Applayout from './layout/applayout'
import { Link } from 'react-router-dom';
import axiosClient from '../axios/axiosClient';
import { toast } from 'react-toastify';
import Pagination from '../components/app/pagination';

function Opencases() {

    const [cases, setCases] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({});
    // const cases = [
    //     {
    //       id: 1,
    //       title: "Community Health Initiative",
    //       beneficiary: "John Doe",
    //       project_officer: "Jane Smith",
    //       action: "View Details"
    //     },
    //     {
    //       id: 2,
    //       title: "School Renovation Program",
    //       beneficiary: "Mary Johnson",
    //       project_officer: "Michael Williams",
    //       action: "View Details"
    //     },
    //     {
    //       id: 3,
    //       title: "Water Supply Project",
    //       beneficiary: "Alex Brown",
    //       project_officer: "Sarah Davis",
    //       action: "View Details"
    //     },
    //     {
    //       id: 4,
    //       title: "Affordable Housing Project",
    //       beneficiary: "Lisa White",
    //       project_officer: "David Clark",
    //       action: "View Details"
    //     },
    //     {
    //       id: 5,
    //       title: "Renewable Energy Program",
    //       beneficiary: "James Green",
    //       project_officer: "Emma Walker",
    //       action: "View Details"
    //     }
    //   ];

      const getOpenCases = (url=`/beneficiary-cases/open`) => {
        axiosClient
          .get(url)
          .then((response) => {
            setCases(response.data.data.data);
            setPagination(response.data.data)
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            toast.error(error.response.data.message);
          });
      };
      const handlePageChange = (url) => {
        getOpenCases(url);
      };
    
      useEffect(() => {

        setLoading(true);
        getOpenCases();
      }, []);
      
    return (
        <Applayout>
         <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col">
              <div className="page-header-left">
                <h3>Open Cases</h3>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                        <i data-feather="home"></i>
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Cases</li>
                  <li className="breadcrumb-item active">Default</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">
            Open Cases
            <div className="pull-right">
            
          </div>
            </h4>
         
          <div className="card-options">
            <a
              className="card-options-collapse"
              href="edit-profile.html#"
              data-toggle="card-collapse"
            >
              <i className="fe fe-chevron-up"></i>
            </a>
            <a
              className="card-options-remove"
              href="edit-profile.html#"
              data-toggle="card-remove"
            >
              <i className="fe fe-x"></i>
            </a>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table card-table table-vcenter text-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Beneficiary</th>
                <th>Project Officer</th>
                <th>Amount Needed</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
                { cases.map((cas, index)=>{
                    // Calculate the correct index based on current page
                    const currentPage = pagination.current_page;
                    const perPage = pagination.per_page;
                    const correctIndex = (currentPage - 1) * perPage + index + 1;

                    return (
                        <tr key={cas.id}>
                            <td>{correctIndex}</td>
                            <td>{cas.title}</td>
                            <td>{cas.beneficiary.first_name + " "+ cas.beneficiary.last_name}</td>
                            <td>{cas.project_officer.first_name+" "+ cas.project_officer.last_name}</td>
                            <td style={{fontSize:"9px"}}>
                              <span>USD: <b>{cas.amount.toLocaleString()}</b></span><br/>
                              {cas.amount_in_local && <>
                              <span>{cas.currency}:<b>{cas.amount_in_local.toLocaleString()}</b></span><br/>
                              <span>rate <b>{cas.local_rate}</b></span><br/>
                              </>}
                            </td>
                            <td>
                              <a class="icon" href="javascript:void(0)" data-bs-original-title="" title=""></a>
                              <Link class="btn btn-success btn-sm" to={`/view-case/${cas.id}`} data-bs-original-title="" title="">
                                <i class="fa fa-file"></i> View Case
                              </Link>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
          </table>
          <Pagination paginationData={pagination} onPageChange={handlePageChange} />
        </div>
      </div>
    </Applayout>
    )
}

export default Opencases
